import useAuth from "../hooks/useAuth";
import usePageTitle from "../utils/usePageTitle";
import { Link } from "react-router-dom";

export default function NotFound() {
  usePageTitle("404");

  const { id, role } = useAuth();

  function handleGoHome() {
    if (id && role) {
      if (role === "student") {
        return `/student/${id}/videos/1`;
      } else if (role === "admin") {
        return `/admin/dashboard`;
      }
    } else {
      return "/home";
    }
  }

  return (
    <>
      <div
        className="text-center"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          WebkitTransform: "translate(-50%, -50%)",
          fontSize: "2rem",
        }}
      >
        Page Not Found
        <div className="flex items-center justify-center w-screen h-screen">
          <div className="px-4 lg:py-12">
            <div className="lg:gap-4 lg:flex">
              <div className="flex flex-col items-center justify-center md:py-24 lg:py-32">
                <h1 className="font-bold text-blue-600 text-9xl">404</h1>
                <p className="mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
                  <span className="text-red-500">Oops!</span>
                </p>
                <p className="mb-8 text-center text-gray-500 md:text-lg">
                  The page you’re looking for doesn’t exist.
                </p>
                <Link
                  to={handleGoHome()}
                  className="px-8 py-3 text-sx font-semibold text-white"
                >
                  <span className="goback">GO BACK</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
